/** @format */
import { FeatureFlagName } from '@toucan/common/services/feature-flags/types';

import { useFeatureFlag } from '@toucan/client/global/feature-flag';

export const useFeatureFlaggedConfig = <T = Record<string, unknown>>(
    featureFlag: FeatureFlagName,
    defaultConfig: Readonly<T>,
    flaggedConfig?: Readonly<T>
): T => {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    const flagActive = Boolean(useFeatureFlag(featureFlag)?.isEnabled);
    if (flagActive && flaggedConfig) {
        return flaggedConfig;
    }
    return defaultConfig;
};
